import React from 'react';
const SvgAudio = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M3 1v30h26V8h-7V1H3z" />
      <path opacity={0.3} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <path fill="#769CC2" d="M22 1l7 7h-7V1z" />
      <g fill="#FFF">
        <path d="M19.6 10.6c-.1.2 0 .6.2.7 2 1.4 3.3 3.6 3.3 6.2 0 2.7-1.4 5-3.5 6.4-.2.1-.3.5-.2.7.1.2.4.3.7.2 2.4-1.5 4.1-4.2 4.1-7.3 0-2.9-1.5-5.5-3.8-7.1-.4-.1-.7 0-.8.2zM11 15H8v5h3l4 3V12z" />
        <path d="M18.1 13.2c-.1.3-.1.6.2.8 1.1.8 1.7 2.1 1.7 3.5 0 1.5-.7 2.8-1.9 3.6-.2.2-.3.5-.2.7.1.2.4.3.7.2 1.5-1 2.4-2.7 2.4-4.6 0-1.8-.9-3.4-2.2-4.4-.3-.1-.6 0-.7.2z" />
        <path d="M16.7 18.4c-.2.2-.3.6-.1.8.1.2.4.3.6.1.5-.5.8-1.1.8-1.8s-.3-1.3-.7-1.8c-.2-.2-.5-.1-.6.1-.1.2-.1.6.1.8.2.2.3.5.3.8-.1.4-.2.7-.4 1z" />
      </g>
    </svg>
  );
});
export default SvgAudio;
SvgAudio.iconName = 'audio';
SvgAudio.displayName = 'SvgAudio';
